import { createContext, useContext, useState } from "react";

interface HistoryPeriodProviderProps {
  children: React.ReactNode;
}

type HistoryPeriodContextType = {
  historyPeriod?: string;
  setHistoryPeriod: (historyPeriod?: string) => void;
};

export const HistoryPeriodContext = createContext<HistoryPeriodContextType>({
  historyPeriod: undefined,
  setHistoryPeriod: () => {},
});

const HistoryPeriodProvider = (props: HistoryPeriodProviderProps) => {
  const [historyPeriod, setHistoryPeriod] = useState<string>();

  return (
    <HistoryPeriodContext.Provider value={{ historyPeriod, setHistoryPeriod }}>
      {props.children}
    </HistoryPeriodContext.Provider>
  );
};

export default HistoryPeriodProvider;

export const useHistoryPeriod = () => {
  const { historyPeriod, setHistoryPeriod } = useContext(HistoryPeriodContext);
  return { historyPeriod, setHistoryPeriod };
};
